import Button from "common/components/Button";
import ButtonMobile from "common/components/ButtonMobile";
import MainPageHeader from "common/components/MainPageHeader";
import React from "react";
import { useNavigate } from "react-router-dom";
import CardIcon from "assets/icons/help/card-help-mobile.png";

interface Props {
  successDataPayment?: any;
}

const ThankYouAfterPaymentMobile = ({ successDataPayment }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="thank-you-wrapper-mobile">
      <MainPageHeader isPricingButtonHidden={true} type="main" />
      <div className="thank-you-container-mobile">
        <h2>תודה שרכשתם מנוי לאתר GoBeB</h2>
        <div className="thank-you-content-mobile">
          <span>
            <strong>פרטי הזמנה:</strong>
          </span>
          <div>
            <div>
              <span className="thank-you-regular-label">
                שם לקוח: {successDataPayment?.customer}
              </span>
            </div>
            <div>
              <span className="thank-you-regular-label">
                מספר הזמנה: {successDataPayment?.orderId}
              </span>
            </div>
            <div>
              <span className="thank-you-regular-label">
                סוג מנוי: {successDataPayment?.product}
              </span>
            </div>
            <div>
              <span className="thank-you-regular-label">
                סכום לתשלום: {successDataPayment?.sum}
              </span>
            </div>
            <div>
              <span className="thank-you-regular-label">
                מספר תשלומים: {successDataPayment?.payments}
              </span>
            </div>
            <div style={{ marginTop: 20 }}>
              <span className="thank-you-regular-label">
                אם נתקלתם בבעיה, יש{" "}
                <strong className="thank-you-link" onClick={() => navigate("/contact")}>
                  לצור קשר
                </strong>{" "}
                ונשמח לסייע
              </span>
            </div>
            <div style={{ marginTop: 20 }}>
              <strong className="thank-you-regular-label-bold">
                הרפתקה נפלאה מחכה לכם - צאו לדרך
              </strong>
            </div>
            <div style={{ marginTop: 60 }}>
              <span>צוות GoBeB</span>
            </div>
          </div>
          <div className="thank-you-container-btn">
            <Button text="התחילו לתרגל" onClick={() => navigate("/main_page")} />
          </div>
        </div>
      </div>
      <div className="footer-mobile">
        <img src={CardIcon} />
      </div>
    </div>
  );
};

export default ThankYouAfterPaymentMobile;
